<template>
  <div class="admissions-compare">
    <HorizontalBar
      height="520"
      title="Leads数、上门数、新签人数"
      :show-keys="barKeys1"
      :query-data.sync="queryData"
    />
    <div class="flex-wrap bar-wrap">
      <HorizontalBar
        class="bar"
        height="420"
        title="上门率"
        :show-keys="barKeys2"
        :query-data.sync="queryData"
        unit="%"
      />
      <HorizontalBar
        class="bar"
        height="420"
        title="上门转新签率"
        :show-keys="barKeys3"
        :query-data.sync="queryData"
        unit="%"
      />
    </div>
  </div>
</template>

<script>
import HorizontalBar from '@/components/chart/HorizontalBar.vue'
export default {
  name: 'AdmissionsCompare',
  components: {
    HorizontalBar
  },
  props: {
    dataInfo: Array
  },
  data() {
    return {
      queryData: [],
      barKeys1: [
        { key: 'through_review_num', name: '新签人数', color: '#4c84ff' },
        { key: 'visit_num', name: '上门量', color: '#34c6ac' },
        { key: 'leads_num', name: 'Leads数', color: '#ffb34c' }
      ],
      barKeys2: [{ key: 'visit_percent', name: '上门率', color: '#4c84ff' }],
      barKeys3: [
        {
          key: 'through_review_percent',
          name: '上门转新签率',
          color: '#4c84ff'
        }
      ]
    }
  },
  watch: {
    dataInfo(val) {
      this.queryData = val.slice(1)
    }
  },
  created() {
    this.queryData = this.dataInfo.slice(1)
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.admissions-compare {
  .bar-wrap {
    flex-wrap: wrap;
    justify-content: space-between;
    .bar {
      margin-top: 40px;
      width: 760px;
    }
  }
}
</style>
